import { trans } from "@mongez/localization";
import { BookOpenCheck, SearchX } from "lucide-react";

type LessonsCatalogEmptyStateProps = {
  hasFilters: boolean;
  onClearFilters: () => void;
};

export function LessonsCatalogEmptyState({
  hasFilters,
  onClearFilters,
}: LessonsCatalogEmptyStateProps) {
  const Icon = hasFilters ? SearchX : BookOpenCheck;

  return (
    <section className="rounded-[2rem] border border-dashed border-slate-300 bg-gradient-to-b from-white to-slate-50 px-5 py-14 text-center dark:border-slate-700 dark:from-slate-900 dark:to-slate-950 sm:py-20">
      <span className="dark:bg-primary-950 mx-auto grid size-20 place-items-center rounded-3xl bg-primary-100 text-primary-700 dark:text-primary-200">
        <Icon className="size-9" />
      </span>
      <h2 className="mt-5 text-xl font-black text-slate-950 dark:text-white sm:text-2xl">
        {hasFilters
          ? trans("grades.noResultsFound")
          : trans("grades.noLessonsAvailable")}
      </h2>
      <p className="mx-auto mt-2 max-w-lg text-sm leading-7 text-slate-500 dark:text-slate-400">
        {hasFilters
          ? trans("grades.noResultsFoundMessage")
          : trans("grades.noLessonsAvailableMessage")}
      </p>
      {hasFilters ? (
        <button
          className="mt-6 rounded-xl bg-slate-950 px-5 py-3 text-sm font-bold text-white transition hover:bg-primary-700 dark:bg-primary-600 dark:hover:bg-primary-500"
          onClick={onClearFilters}
          type="button"
        >
          {trans("lessonCatalog.showAllLessons")}
        </button>
      ) : null}
    </section>
  );
}
